import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

import { resetPassword } from "../../services/AuthService";
import HelperFormButtons from "../../components/HelperFormButtons";
import yup from "../../utils/yup";
import Form from "../../components/form/Form";

const ResetPassword = () => {
  const resetPasswordSchema = yup
    .object()
    .shape({
      identifier: yup
        .string("The email or phone number is not valid.")
        .required("The email or phone number is required.")
        .test(
          "identifier-check",
          "The email or phone number is not valid.",
          (value) =>
            RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$").test(
              value
            ) ||
            RegExp(
              "^((\\+[1-9]{1,4}[ -]?)|(\\([0-9]{2,3}\\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$"
            ).test(value)
        ),
    })
    .required();

  const formDetails = {
    label: "Reset your password",
    submitButtonLabel: "Reset Password",
    steps: [
      {
        name: "identifier",
        label: "E-mail or phone number",
        type: "text",
      },
    ],
  };

  const form = useForm({
    resolver: yupResolver(resetPasswordSchema),
    mode: "onChange",
  });

  const additionalFormButtons = [
    {
      label: "Forgot password",
      route: "/reset-password",
    },
    {
      label: "Register",
      route: "/register",
    },
  ];

  return (
    <Container>
      <Form
        formDetails={formDetails}
        form={form}
        onSubmit={resetPassword(form.setError)}
      />
      <Container className="mt-2">
        <Row>
          <HelperFormButtons formButtons={additionalFormButtons} />
        </Row>
      </Container>
    </Container>
  );
};

export default ResetPassword;
